export class BusinessProspectApplicationDetails {
    public id: number = 0;
    public name: string = '';
    public url: string = '';

    constructor(json?: any) {
        if (!json) {
            return;
        }

        Object.assign(this, json);
    }
}
